// extracted by mini-css-extract-plugin
var _1 = "ProfileInfoWidgetSkeleton-moduleProfileInfoWidgetSkeleton__LZocj";
var _2 = "ProfileInfoWidgetSkeleton-moduledivider__t1ZQ2 Divider-moduleDivider__dL3Vg";
var _3 = "ProfileInfoWidgetSkeleton-moduleitem__uDk3z";
var _4 = "ProfileInfoWidgetSkeleton-modulelabel__p0Brg Skeleton-moduleSkeleton__Mlrfv";
var _5 = "ProfileInfoWidgetSkeleton-modulevalue__x9X4r";
var _6 = "ProfileInfoWidgetSkeleton-modulevalueBar__nfVGR Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "ProfileInfoWidgetSkeleton", _2 as "divider", _3 as "item", _4 as "label", _5 as "value", _6 as "valueBar" }
